import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원 가동률(공장>스테이지>자원별 가동시간/휴지시간/작업교체시간/대기시간) — 크로스탭 그리드용.
// AnalysisController#getResrUtilization(백엔드는 factoryplan/analysis/resource-utilization).
// getPlanResults와 마찬가지로 { crosstabHeader, chartHeader, data[].pivotData } 형태.
const getResrcUtilization = (params) => fpApiUtil.postParams(`${ANALYSIS}/resource-utilization`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/resourceCd)으로 드릴다운.
// changes(FilterParameter: plantCds/stageCds/resourceCds/analysisIndicators 등)는 1차 미이관이라
// 항상 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e).
const getResrcUtilizationChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/resource-utilization`, { params, changes });

const fpResourceUtilizationService = { getResrcUtilization, getResrcUtilizationChart };
export default fpResourceUtilizationService;
